import { render, staticRenderFns } from "./navigation_cart.vue?vue&type=template&id=2bda4d48&lang=html&"
import script from "./navigation_cart.vue?vue&type=script&lang=js&"
export * from "./navigation_cart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports